import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/ui/PageHeader';
import { StaffOnly } from '@/features/admin-content/StaffOnly';
import { useCan } from '@/features/admin-content/use-current-user';
import { ActivityHistory } from '@/features/staff-workspace/ActivityHistory';

export const Route = createFileRoute('/admin/history')({
  component: AdminHistoryPage,
});

function AdminHistoryPage() {
  const allowed = useCan('activity.read');
  if (!allowed) {
    return (
      <StaffOnly
        title="You cannot open the history"
        description="Ask an admin if you need to see who changed what."
      />
    );
  }
  return (
    <div className="grid gap-6">
      <PageHeader
        eyebrow="Staff portal"
        title="History"
        description="Every change by staff: who, when and what. Entries cannot be edited or deleted."
      />
      <ActivityHistory />
    </div>
  );
}
